@if (!isMatItem) {
  <button mat-stroked-button [disableRipple]="true" (click)="openCancelDialog(meeting)">
    {{ displayText ? displayText : ('MEETING_SCHEDULER.MEETING_ACTIONS.CANCEL_MEETING' | translate) }}
  </button>
}

@if (isMatItem) {
  <div class="cancel-mat-menu-item" (click)="openCancelDialog(meeting)">
    {{ displayText ? displayText : ('MEETING_SCHEDULER.MEETING_ACTIONS.CANCEL_MEETING' | translate) }}
  </div>
}
